import { appDoLog } from './JS2NativeInterface';

export const logger = {
	log: console.log,
	warn: console.warn,
	error: console.error,
	groupCollapsed: console.groupCollapsed,
	group: console.group,
	groupEnd: console.groupEnd,
};

export function initNativeLogging() {
	logger.log = appDoLog;
	logger.warn = appDoLog;
	logger.error = appDoLog;
}
